import { postData } from '../utils/ajax-utils';
/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initSearchSuggestionsAutocomplete(): void {
    document.querySelectorAll<HTMLFormElement>('.js-search-suggestions-autocomplete').forEach($el => {
        new SearchSuggestionsAutocomplete($el);
    });
}

class SearchSuggestionsAutocomplete {
    $el: HTMLElement;
    $suggestions: HTMLElement | null;
    $autocomplete: HTMLElement | null;
    $form: HTMLFormElement | null;
    $searchInput: HTMLInputElement | null | undefined;
    $controller: AbortController;
    searchTimeout: number | null = null;
    searchDelay: number = 500; // Délai en ms avant de lancer la recherche
    minChars: number = 3; // Nombre minimum de caractères pour déclencher la recherche

    constructor($el: HTMLFormElement) {
        this.$el = $el;
        this.$suggestions = this.$el.querySelector('.suggestions');
        this.$autocomplete = this.$el.querySelector('.autocomplete');
        this.$form = this.$el.querySelector('.js-search-form');
        this.$searchInput = this.$form?.querySelector<HTMLInputElement>('input[type="search"]');
        this.$controller = new AbortController();
        this.$form?.setAttribute('autocomplete', 'off');
        this.$searchInput?.setAttribute('autocomplete', 'off');
        this.initListeners();
    }

    initListeners(): void {
        const searchInput = this.$searchInput;

        if (searchInput) {
            searchInput.addEventListener('focus', () => {
                if (searchInput.value.trim() === '') {
                    this.showSuggestions();
                } else {
                    this.reopenAutocompleteIfNotEmpty();
                }
                
            });

            searchInput.addEventListener('click', () => {
                if (searchInput.value.trim() === '') {
                    this.showSuggestions();
                } else {
                    const list = this.$autocomplete?.querySelector('ul');
                    if (list && !list.children.length) {
                        this.fetchSuggestions()
                    } else {
                        this.reopenAutocompleteIfNotEmpty();
                    }
                }
            });

            searchInput.addEventListener('input', () => {
                const inputValue = searchInput.value.trim();

                // Cacher .suggestions si l'utilisateur commence à taper
                if (inputValue.length > 0) {
                    this.hideSuggestions();
                } else {
                    this.hideAutocomplete(); // Masquer .autocomplete quand input vide
                    this.hideLoading(); // Cacher loading si input vide
                }

                // Annuler timeout précédent
                if (this.searchTimeout !== null) {
                    clearTimeout(this.searchTimeout);
                    this.hideLoading(); // Cacher loading si timeout annulé
                }

                // Lancer une requête si minChars atteint
                if (inputValue.length >= this.minChars) {
                    this.showLoading(); // Afficher loading avant le délai
                    this.searchTimeout = window.setTimeout(() => {
                        this.fetchSuggestions();
                    }, this.searchDelay);
                }
            });

            searchInput.addEventListener('keypress', (event) => {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    const inputValue = searchInput.value.trim();

                    if (inputValue.length >= this.minChars) {
                        if (this.searchTimeout !== null) {
                            clearTimeout(this.searchTimeout);
                            this.searchTimeout = null;
                        }
                        this.$form?.submit();
                    }
                }
            });
        }

        // Cacher les suggestions si clic hors du bloc
        document.addEventListener('click', (event) => {
            const target = event.target as Node;
            if (!this.$el.contains(target)) {
                this.hideSuggestions();
                this.hideAutocomplete();
            }
        });
    }

    async fetchSuggestions(): Promise<void> {
        if (!this.$autocomplete) return;

        const searchInput = this.$searchInput;
        const inputValue = searchInput?.value.trim() || '';

        if (inputValue.length < this.minChars) return;

        this.$controller.abort();
        this.$controller = new AbortController();

        const formData = new URLSearchParams();
        formData.append('action', 'search_suggestions');
        formData.append('term', inputValue);
        if (this.$el.dataset.post_type) {
            formData.append('post_type', this.$el.dataset.post_type);
        }

        postData(script_var.ajax_url, formData).then(response => {
            this.hideLoading(); // Cacher loading quand la réponse arrive
            
            if (response.success) {
                const ul = this.$autocomplete!.querySelector('ul');
                if (!ul) return;

                ul.innerHTML = ''; // Nettoyer les résultats précédents

                response.data.forEach((item: { title: string; url: string }) => {
                    const li = document.createElement('li');
                    const a = document.createElement('a');
                    a.href = item.url;
                    a.textContent = item.title;
                    li.appendChild(a);
                    ul.appendChild(li);
                });

                this.showAutocomplete();
            }
        }).catch(error => {
            this.hideLoading(); // Cacher loading même en cas d'erreur
            if (error.name !== 'AbortError') {
                console.error('Erreur lors de la recherche:', error);
            }
        });
    }

    showSuggestions(): void {
        this.$suggestions?.classList.add('visible');
    }

    hideSuggestions(): void {
        this.$suggestions?.classList.remove('visible');
    }

    showAutocomplete(): void {
        this.$autocomplete?.classList.add('visible');
    }

    hideAutocomplete(): void {
        this.$autocomplete?.classList.remove('visible');
    }

    reopenAutocompleteIfNotEmpty(): void {
        const list = this.$autocomplete?.querySelector('ul');
        
        if (list && list.children.length > 0) {
            this.showAutocomplete();
        }
    }

    showLoading(): void {
        this.$form?.classList.add('loading');
    }

    hideLoading(): void {
        this.$form?.classList.remove('loading');
    }
}
